import { UIFlightSegment } from "@flights/types";
import Frame from "../../../../Frame";
import { FC } from "react";
import React from "react";
import { useCardSegmentsCondensedController } from "./useCardSegmentsCondensed.controller";
import { CardSegment } from "@flights/search-ui";
import { Stack, Text, useViewport } from "@bookingcom/bui-react";
import { trackWithDefaultStage } from "@flights/et-universal";

export const CardSegmentsCondensed: FC<{ segments: UIFlightSegment[]; bigLogo?: boolean }> = ({
  segments,
  bigLogo
}) => {
  const { segmentsData, carrierText } = useCardSegmentsCondensedController(segments);
  const { isSmall } = useViewport();
  const isResponsiveFixesSm = isSmall && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  return (
    <>
      <Frame>
        <Stack gap={2}>
          {segmentsData.map((segmentData, index) => (
            <CardSegment
              key={index}
              {...segmentData}
              size={bigLogo ? "large" : "medium"}
              index={index}
              isResponsiveFixesSm={isResponsiveFixesSm}
            />
          ))}
        </Stack>
      </Frame>
      <Frame mt={2} direction="row" wrap="wrap">
        <Text variant="small_1" attributes={{ "data-testid": "flight_card_carriers" }}>
          {carrierText}
        </Text>
      </Frame>
    </>
  );
};
